var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDragonCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 860,
    height: 904,
    viewBox: "0 0 860 904",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_220_7689)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_220_7689",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 108,
    width: 646,
    height: 646
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M691.933 423.215C692.029 414.445 704.043 411.275 708.163 419.167C712.1 426.708 708.601 442.365 707.838 450.644C704.754 484.116 696.747 516.853 684.1 547.97C646.806 639.733 567.756 713.83 472.62 741.436C435.301 752.265 396.028 756.338 357.314 752.7C167.579 734.871 31.5832 546.927 70.7481 359.852C78.5843 322.422 93.0589 286.947 113.451 254.662C-12.4247 453.985 125.081 728.994 359.992 744.586C396.308 746.996 433 742.784 467.818 732.126C506.242 720.364 542.166 700.845 573.274 675.342C607.681 647.135 636.135 611.726 656.449 572.055C680.191 525.687 691.365 475.182 691.933 423.215ZM254.847 134.541C426.809 61.0627 633.391 145.011 692.918 326.331C703.11 357.374 709.043 390.289 709.147 423.032C709.178 432.783 695.051 435.09 692.282 425.624C689.241 415.229 690.902 388.947 689.096 375.683C682.69 328.655 665.288 283.396 638.507 244.292C554.576 121.74 390.435 76.8173 254.847 134.541Z",
    fill: "#4A3AFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M382.683 724.006C548.026 724.006 682.062 589.324 682.062 423.185C682.062 257.047 548.026 122.365 382.683 122.365C217.341 122.365 83.304 257.047 83.304 423.185C83.304 589.324 217.341 724.006 382.683 724.006Z",
    stroke: "#4243AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M382.683 705.438C537.82 705.438 663.583 579.069 663.583 423.185C663.583 267.301 537.82 140.933 382.683 140.933C227.546 140.933 101.783 267.301 101.783 423.185C101.783 579.069 227.546 705.438 382.683 705.438Z",
    stroke: "#4243AF",
    strokeWidth: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M382.683 687.172C527.78 687.172 645.404 568.308 645.404 421.681C645.404 275.055 527.78 156.191 382.683 156.191C237.586 156.191 119.961 275.055 119.961 421.681C119.961 568.308 237.586 687.172 382.683 687.172Z",
    stroke: "#4243AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M382.682 686.87C527.614 686.87 645.104 568.815 645.104 423.185C645.104 277.556 527.614 155.814 382.683 155.814C237.751 155.814 120.261 277.556 120.261 423.185C120.261 568.815 237.751 686.87 382.682 686.87Z",
    stroke: "#4243AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M382.683 668.302C517.409 668.302 626.626 558.56 626.626 423.185C626.626 287.811 517.409 178.068 382.683 178.068C247.957 178.068 138.74 287.811 138.74 423.185C138.74 558.56 247.957 668.302 382.683 668.302Z",
    stroke: "#4243AF",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_220_7689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1072.21 574.267C1072.21 953.122 823.86 1260.06 517.712 1260.06C211.564 1260.06 -36.7881 953.122 -36.7881 574.267C-36.7881 195.413 211.564 -111.521 517.712 -111.521C823.86 -111.521 1072.21 195.413 1072.21 574.267Z",
    fill: "#ACFF01",
    stroke: "#4243AF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_220_7689)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.128,
    cy: 134.602,
    rx: 396.128,
    ry: 134.602,
    transform: "matrix(0.965614 -0.259981 0.257662 0.966235 -293.288 657.652)",
    fill: "#1A701D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.924 581.868C510.657 599.617 504.607 619.448 489.445 640.16C474.285 660.866 450.066 682.381 418.62 703.45C355.732 745.585 264.041 785.869 158.453 814.297C52.8652 842.726 -46.5873 853.905 -122.016 849.01C-159.733 846.563 -191.414 840.098 -214.845 829.782C-238.283 819.463 -253.39 805.329 -258.124 787.579C-262.857 769.829 -256.807 749.998 -241.644 729.287C-226.485 708.581 -202.265 687.065 -170.819 665.996C-107.932 623.862 -16.2407 583.578 89.3474 555.149C194.935 526.721 294.388 515.542 369.816 520.436C407.533 522.884 439.214 529.348 462.646 539.665C486.083 549.983 501.191 564.118 505.924 581.868Z",
    stroke: "#4243AF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_220_7689)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 87.7356,
    cy: 134.602,
    rx: 87.7356,
    ry: 134.602,
    transform: "matrix(0.965614 -0.259981 0.257662 0.966235 725.712 203.894)",
    fill: "#1A701D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.348 288.462C938.904 324.296 938.087 359.263 929.066 386.822C920.044 414.385 902.843 434.475 879.665 440.715C856.488 446.955 831.594 438.2 810.065 418.862C788.54 399.527 770.432 369.655 760.876 333.821C751.321 297.986 752.138 263.019 761.158 235.461C770.181 207.897 787.382 187.807 810.559 181.567C833.737 175.327 858.63 184.083 880.16 203.421C901.685 222.755 919.792 252.627 929.348 288.462Z",
    stroke: "#4243AF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_220_7689)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 225.332,
    cy: 216.341,
    rx: 225.332,
    ry: 216.341,
    transform: "matrix(0.864983 -0.501802 0.4982 0.867062 522.712 698.925)",
    fill: "#01FF39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.88 660.613C1079.26 763.955 1040.36 898.262 932.933 960.581C825.51 1022.9 690.304 989.597 630.925 886.255C571.547 782.913 610.446 648.606 717.869 586.286C825.292 523.967 960.498 557.271 1019.88 660.613Z",
    stroke: "#4243AF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_220_7689)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.567,
    cy: 99.3398,
    rx: 108.567,
    ry: 99.3398,
    transform: "matrix(0.864983 -0.501802 0.4982 0.867062 57.7495 165.527)",
    fill: "#128F16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.625 142.954C321.8 190.249 302.053 252.912 250.391 282.882C198.729 312.853 134.848 298.706 107.673 251.41C80.4979 204.115 100.245 141.453 151.907 111.482C203.569 81.511 267.45 95.6585 294.625 142.954Z",
    stroke: "#4243AF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_220_7689)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.839,
    cy: 151.744,
    rx: 165.839,
    ry: 151.744,
    transform: "matrix(0.864983 -0.501802 0.4982 0.867062 135.712 851.233)",
    fill: "#128F16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M497.774 816.62C539.368 889.01 509.131 984.882 430.109 1030.73C351.087 1076.57 253.338 1054.94 211.744 982.554C170.149 910.164 200.387 814.292 279.409 768.449C358.431 722.606 456.18 744.229 497.774 816.62Z",
    stroke: "#4243AF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_220_7689)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 397.728,
    cy: 130.083,
    rx: 397.728,
    ry: 130.083,
    transform: "matrix(0.304728 -0.952439 0.951583 0.307392 364.032 482.77)",
    fill: "#01FF39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.062 -234.391C746.941 -228.939 759.751 -213.25 768.403 -189.364C777.053 -165.486 781.512 -133.503 781.746 -95.6391C782.214 -19.9174 765.782 79.2077 732.325 183.778C698.869 288.347 654.735 378.524 610.44 439.786C588.291 470.419 566.118 493.799 545.241 508.139C524.357 522.484 504.848 527.733 487.969 522.28C471.09 516.828 458.281 501.14 449.628 477.253C440.979 453.375 436.52 421.392 436.286 383.528C435.818 307.807 452.25 208.682 485.707 104.112C519.163 -0.458072 563.297 -90.6345 607.592 -151.897C629.741 -182.53 651.913 -205.91 672.791 -220.25C693.675 -234.595 713.183 -239.844 730.062 -234.391Z",
    stroke: "#4243AF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_220_7689)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.082,
    cy: 130.083,
    rx: 101.082,
    ry: 130.083,
    transform: "matrix(0.304728 -0.952439 0.951583 0.307392 -24.2881 495.517)",
    fill: "#01FF39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.95 343.431C229.17 365.468 270.503 426.259 253.609 479.062C236.715 531.865 167.87 557.064 99.6493 535.027C31.4289 512.99 -9.90389 452.199 6.99015 399.396C23.8842 346.593 92.729 321.393 160.95 343.431Z",
    stroke: "#4243AF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_220_7689",
    x: -86,
    y: -42,
    width: 946,
    height: 946,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.00392157 0 0 0 0 1 0 0 0 0 0.223059 0 0 0 0.56 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_220_7689"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_220_7689",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_220_7689",
    x: -380.2,
    y: 398.822,
    width: 1008.2,
    height: 571.802,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_220_7689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_220_7689",
    x: 633.546,
    y: 59.0771,
    width: 423.134,
    height: 504.128,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_220_7689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_220_7689",
    x: 482.636,
    y: 434.376,
    width: 685.529,
    height: 678.115,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_220_7689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_220_7689",
    x: 24.9761,
    y: 25.2524,
    width: 352.346,
    height: 343.859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur_220_7689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_220_7689",
    x: 122.577,
    y: 673.886,
    width: 464.365,
    height: 451.401,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 35,
    result: "effect1_foregroundBlur_220_7689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_220_7689",
    x: 315.776,
    y: -357.003,
    width: 586.479,
    height: 1001.9,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_220_7689"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_220_7689",
    x: -117.291,
    y: 214.954,
    width: 495.18,
    height: 448.551,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 60,
    result: "effect1_foregroundBlur_220_7689"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragonCircle);
export default __webpack_public_path__ + "static/media/dragon-circle.6d87e593b5bc1fe1e6f8867052e696b3.svg";
export { ForwardRef as ReactComponent };